module.exports = __webpack_public_path__ + "static/media/icon-pdf.b740d994.svg";